const divCardsTimeLine = {
  action: 'Acción',
  item: 'Elemento relacionado',
  service: 'Servicio',
  accountable: 'Responsables'
};

export default divCardsTimeLine;
